import apiClient from "../apiClient";

const suspendDriver = (data) => apiClient.post("/admin/suspend-driver", data);

const enableDriver = (data) => apiClient.post("/admin/unsuspend-driver", data);

const deleteDriver = (data) =>
  apiClient.delete("/admin/driver", { data: data });

const acceptOnboardingDriver = (data) =>
  apiClient.post("/admin/accept-onboarding-driver", data);

const rejectOnboardingDriver = (data) =>
  apiClient.post("/admin/reject-onboarding-driver", data);

const fetchDriverWeeklyPayments = (data) =>
  apiClient.post("/admin/payments-driver", data);

const updateShiftSchedule = (data) =>
  apiClient.post("/admin/update-shift-schedule", data);

const updatePoints = (data) => apiClient.post("/admin/update-points", data);

const updateDriver = (data) => apiClient.put("/admin/update-driver", data);

export default {
  suspendDriver,
  enableDriver,
  deleteDriver,
  acceptOnboardingDriver,
  rejectOnboardingDriver,
  fetchDriverWeeklyPayments,
  updateShiftSchedule,
  updatePoints,
  updateDriver,
};
